import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { normalizeRepairReportDetail } from './normalizeRepairReportDetail';
import { serializeRepairReportUpdate } from './serialize';

/**
 * 更新維修報告草稿。
 * PATCH `/aftersales/repair-report/{id}`。僅 DRAFT。
 *
 * @param {string} id
 * @param {object} payload
 */
export async function updateRepairReport(id, payload) {
  const { data: raw } = await request.patch(
    `/aftersales/repair-report/${id}`,
    serializeRepairReportUpdate(payload),
  );
  const parsed = parseVer4DetailResponse(raw);
  return {
    ...parsed,
    data: normalizeRepairReportDetail(parsed.data),
  };
}
